import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Laverage(props) {
  return (
    <div className="laverage_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>TekRevol's Efficient Steps to Mobile App Success</h2>
            <p>
              From app developers in Dallas to quality assurance specialists to
              visionaries, TekRevol is home to some of the most experienced
              talents that supercharge your app idea and bring it to life. As
              the leading mobile development company in Dallas, we are going to
              provide complete app-building consultancy and a transparent
              process that will justify all the expenses.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h6>Ideation</h6>
                <p>
                  Conduct thorough research to pen down the necessary features
                  for the application.
                </p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h6>Design</h6>
                <p>
                  Initiate with the UI/UX designing of the application for the
                  clients.
                </p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h6>Development</h6>
                <p>
                  Our professional app developers in Denver start off with
                  quality-enriched app development.
                </p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h6>Quality Assurance</h6>
                <p>
                  Testing the application, ensuring no bugs remain unsolved.
                </p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h6>Maintenance & Support</h6>
                <p>
                  Solving the issues in the application, post-delivery; if any.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
